import React, { useState } from "react";
import "./AddClientOverlay.css";

const AddClientOverlay = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    clientName: "",
    phoneNumber: "",
    shopAddress: "",
    town: "",
    businessCategory: "",
    interestedInSoftware: null,
    interestedInHardware: null,
    requestedDemo: null,
  });

  const [errors, setErrors] = useState({});

  const businessCategories = [
    "Supermarket",
    "Pharmacy",

    "Fashion & Clothing",
    "Restaurant/Food",
    "Beauty & Cosmetics",
    "Hardware Store",
    "Bookshop",
    "Jewelry",
    "Sports & Fitness",
    "Others",
    ...listOfProductCategory,
  ].sort();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error for this field
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleRadioChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.clientName.trim()) {
      newErrors.clientName = "Client name is required";
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^\+?[0-9]{8,15}$/.test(formData.phoneNumber.replace(/\s/g, ""))) {
      /* !/^[0-9]{10,11}$/.test(formData.phoneNumber.replace(/\s/g, "")) */
      newErrors.phoneNumber = "Please enter a valid phone number";
    }

    if (!formData.shopAddress.trim()) {
      newErrors.shopAddress = "Shop address is required";
    }

    if (!formData.businessCategory) {
      newErrors.businessCategory = "Please select a business category";
    }
    if (!formData.town) {
      newErrors.town = "Please select a location";
    }

    if (formData.interestedInSoftware === null) {
      newErrors.interestedInSoftware = "Please select an option";
    }

    if (formData.interestedInHardware === null) {
      newErrors.interestedInHardware = "Please select an option";
    }

    if (formData.requestedDemo === null) {
      newErrors.requestedDemo = "Please select an option";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
      handleClose();
    }
  };

  const handleClose = () => {
    setFormData({
      clientName: "",
      phoneNumber: "",
      shopAddress: "",
      town: "",
      businessCategory: "",
      interestedInSoftware: null,
      interestedInHardware: null,
      requestedDemo: null,
    });
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className='storelense-add-client-overlay-backdrop' onClick={handleClose}>
      <div className='storelense-add-client-overlay-container' onClick={(e) => e.stopPropagation()}>
        <div className='storelense-add-client-overlay-header'>
          <h2 className='storelense-add-client-overlay-title'>Add New Client</h2>
          <button className='storelense-add-client-overlay-close-btn' onClick={handleClose} type='button'>
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
              <path d='M18 6L6 18M6 6l12 12' />
            </svg>
          </button>
        </div>

        <form className='storelense-add-client-overlay-form' onSubmit={handleSubmit}>
          <div className='storelense-add-client-overlay-form-grid'>
            {/* Client Name */}
            <div className='storelense-add-client-overlay-form-group'>
              <label className='storelense-add-client-overlay-label'>
                Client Name <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <input
                type='text'
                name='clientName'
                value={formData.clientName}
                onChange={handleChange}
                placeholder="Enter client's full name"
                className={`storelense-add-client-overlay-input ${errors.clientName ? "storelense-add-client-overlay-input-error" : ""}`}
              />
              {errors.clientName && <span className='storelense-add-client-overlay-error-text'>{errors.clientName}</span>}
            </div>

            {/* Phone Number */}
            <div className='storelense-add-client-overlay-form-group'>
              <label className='storelense-add-client-overlay-label'>
                Phone Number <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <input
                type='tel'
                name='phoneNumber'
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder='0801 234 5678'
                className={`storelense-add-client-overlay-input ${errors.phoneNumber ? "storelense-add-client-overlay-input-error" : ""}`}
              />
              {errors.phoneNumber && <span className='storelense-add-client-overlay-error-text'>{errors.phoneNumber}</span>}
            </div>

            {/* Shop Address */}
            <div className='storelense-add-client-overlay-form-group storelense-add-client-overlay-full-width'>
              <label className='storelense-add-client-overlay-label'>
                Shop Address <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <input
                type='text'
                name='shopAddress'
                value={formData.shopAddress}
                onChange={handleChange}
                placeholder='Enter complete shop address'
                className={`storelense-add-client-overlay-input ${errors.shopAddress ? "storelense-add-client-overlay-input-error" : ""}`}
              />
              {errors.shopAddress && <span className='storelense-add-client-overlay-error-text'>{errors.shopAddress}</span>}
            </div>

            {/* town */}
            <div className='storelense-add-client-overlay-form-group storelense-add-client-overlay-full-width'>
              <label className='storelense-add-client-overlay-label'>
                Town <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <select
                name='town'
                value={formData.town}
                onChange={handleChange}
                className={`storelense-add-client-overlay-select ${errors.town ? "storelense-add-client-overlay-input-error" : ""}`}
              >
                <option value=''>Select location</option>
                {towns.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
              {errors.town && <span className='storelense-add-client-overlay-error-text'>{errors.town}</span>}
            </div>

            {/* Business Category */}
            <div className='storelense-add-client-overlay-form-group storelense-add-client-overlay-full-width'>
              <label className='storelense-add-client-overlay-label'>
                Business Category <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <select
                name='businessCategory'
                value={formData.businessCategory}
                onChange={handleChange}
                className={`storelense-add-client-overlay-select ${errors.businessCategory ? "storelense-add-client-overlay-input-error" : ""}`}
              >
                <option value=''>Select business category</option>
                {businessCategories.map((category, i) => (
                  <option key={i} value={category}>
                    {category}
                  </option>
                ))}
              </select>
              {errors.businessCategory && <span className='storelense-add-client-overlay-error-text'>{errors.businessCategory}</span>}
            </div>

            {/* Interested in Software */}
            <div className='storelense-add-client-overlay-form-group storelense-add-client-overlay-full-width'>
              <label className='storelense-add-client-overlay-label'>
                Is client interested in the software? <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <div className='storelense-add-client-overlay-radio-group'>
                <label className='storelense-add-client-overlay-radio-label'>
                  <input
                    type='radio'
                    name='interestedInSoftware'
                    checked={formData.interestedInSoftware === true}
                    onChange={() => handleRadioChange("interestedInSoftware", true)}
                    className='storelense-add-client-overlay-radio'
                  />
                  <span>Yes</span>
                </label>
                <label className='storelense-add-client-overlay-radio-label'>
                  <input
                    type='radio'
                    name='interestedInSoftware'
                    checked={formData.interestedInSoftware === false}
                    onChange={() => handleRadioChange("interestedInSoftware", false)}
                    className='storelense-add-client-overlay-radio'
                  />
                  <span>No</span>
                </label>
              </div>
              {errors.interestedInSoftware && <span className='storelense-add-client-overlay-error-text'>{errors.interestedInSoftware}</span>}
            </div>

            {/* Interested in Hardware */}
            <div className='storelense-add-client-overlay-form-group storelense-add-client-overlay-full-width'>
              <label className='storelense-add-client-overlay-label'>
                Is client interested in the hardware? <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <div className='storelense-add-client-overlay-radio-group'>
                <label className='storelense-add-client-overlay-radio-label'>
                  <input
                    type='radio'
                    name='interestedInHardware'
                    checked={formData.interestedInHardware === true}
                    onChange={() => handleRadioChange("interestedInHardware", true)}
                    className='storelense-add-client-overlay-radio'
                  />
                  <span>Yes</span>
                </label>
                <label className='storelense-add-client-overlay-radio-label'>
                  <input
                    type='radio'
                    name='interestedInHardware'
                    checked={formData.interestedInHardware === false}
                    onChange={() => handleRadioChange("interestedInHardware", false)}
                    className='storelense-add-client-overlay-radio'
                  />
                  <span>No</span>
                </label>
              </div>
              {errors.interestedInHardware && <span className='storelense-add-client-overlay-error-text'>{errors.interestedInHardware}</span>}
            </div>

            {/* Requested Demo */}
            <div className='storelense-add-client-overlay-form-group storelense-add-client-overlay-full-width'>
              <label className='storelense-add-client-overlay-label'>
                Did client request a demo? <span className='storelense-add-client-overlay-required'>*</span>
              </label>
              <div className='storelense-add-client-overlay-radio-group'>
                <label className='storelense-add-client-overlay-radio-label'>
                  <input
                    type='radio'
                    name='requestedDemo'
                    checked={formData.requestedDemo === true}
                    onChange={() => handleRadioChange("requestedDemo", true)}
                    className='storelense-add-client-overlay-radio'
                  />
                  <span>Yes</span>
                </label>
                <label className='storelense-add-client-overlay-radio-label'>
                  <input
                    type='radio'
                    name='requestedDemo'
                    checked={formData.requestedDemo === false}
                    onChange={() => handleRadioChange("requestedDemo", false)}
                    className='storelense-add-client-overlay-radio'
                  />
                  <span>No</span>
                </label>
              </div>
              {errors.requestedDemo && <span className='storelense-add-client-overlay-error-text'>{errors.requestedDemo}</span>}
            </div>
          </div>

          <div className='storelense-add-client-overlay-actions'>
            <button type='button' onClick={handleClose} className='storelense-add-client-overlay-cancel-btn'>
              Cancel
            </button>
            <button type='submit' className='storelense-add-client-overlay-submit-btn'>
              Add Client
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddClientOverlay;

const towns = [
  "Umuahia – Abia State",
  "Aba – Abia State",
  "Yola – Adamawa State",
  "Mubi – Adamawa State",
  "Uyo – Akwa Ibom State",
  "Ikot Ekpene – Akwa Ibom State",
  "Awka – Anambra State",
  "Onitsha – Anambra State",
  "Bauchi – Bauchi State",
  "Azare – Bauchi State",
  "Yenagoa – Bayelsa State",
  "Sagbama – Bayelsa State",
  "Makurdi – Benue State",
  "Gboko – Benue State",
  "Maiduguri – Borno State",
  "Bama – Borno State",
  "Calabar – Cross River State",
  "Ikom – Cross River State",
  "Asaba – Delta State",
  "Warri – Delta State",
  "Abakaliki – Ebonyi State",
  "Onueke – Ebonyi State",
  "Benin City – Edo State",
  "Ekpoma – Edo State",
  "Ado-Ekiti – Ekiti State",
  "Ikere-Ekiti – Ekiti State",
  "Enugu – Enugu State",
  "Nsukka – Enugu State",
  "Gombe – Gombe State",
  "Kumo – Gombe State",
  "Owerri – Imo State",
  "Okigwe – Imo State",
  "Dutse – Jigawa State",
  "Hadejia – Jigawa State",
  "Kaduna – Kaduna State",
  "Zaria – Kaduna State",
  "Kano – Kano State",
  "Wudil – Kano State",
  "Katsina – Katsina State",
  "Funtua – Katsina State",
  "Birnin Kebbi – Kebbi State",
  "Yauri – Kebbi State",
  "Lokoja – Kogi State",
  "Okene – Kogi State",
  "Ilorin – Kwara State",
  "Jebba – Kwara State",
  "Ikeja – Lagos State",
  "Lagos – Lagos State",
  "Lafia – Nasarawa State",
  "Akwanga – Nasarawa State",
  "Minna – Niger State",
  "Kontagora – Niger State",
  "Abeokuta – Ogun State",
  "Ijebu Ode – Ogun State",
  "Akure – Ondo State",
  "Owo – Ondo State",
  "Osogbo – Osun State",
  "Ife – Osun State",
  "Ibadan – Oyo State",
  "Oyo – Oyo State",
  "Jos – Plateau State",
  "Bukuru – Plateau State",
  "Port Harcourt – Rivers State",
  "Degema – Rivers State",
  "Sokoto – Sokoto State",
  "Gusau – Sokoto State",
  "Jalingo – Taraba State",
  "Serti – Taraba State",
  "Damaturu – Yobe State",
  "Potiskum – Yobe State",
  "Gusau – Zamfara State",
  "Tsafe – Zamfara State",
  "Abuja – Federal Capital Territory",
];

export const listOfProductCategory = [
  "Agriculture",
  "Automotive",
  "Baby Products",
  "Beauty & Personal Care",
  "Books & Stationery",
  "Building Materials",
  "Cameras & Photography",
  "Computers & Laptops",
  "Decorations",
  "DIY & Tools",
  "Drinks & Water",
  "Electronics",
  "Fashion",
  "Fitness & Gym Equipment",
  "Food & Beverages",
  "Furniture",
  "Gaming",
  "Grocery",
  "Health and Beauty",
  "Home and Office",
  "Home Appliances",
  "Jewelleries",
  "Kitchen Appliances",
  "Kitchen Utensils",
  "Lightnings & Wiring",
  "Luggage & Bags",
  "Medical Supplies",
  "Mobile Phones",
  "Motor Spare Parts",
  "Music Instruments",
  "Outdoor & Garden",
  "Paints & Brush",
  "PC & Desktops",
  "Pet Supplies",
  "Phone Accessories",
  "Phones and Tablets",
  "Security & Surveillance",
  "Sex Toys",
  "Shoes & Footwear",
  "Smart Home Devices",
  "Software",
  "Sporting Goods",
  "Toys and Games",
  "Watches",
].sort();
